export default {
  getTimeByUnix(unix){
    let date = new Date(unix);
    return date.toLocaleDateString();
  }
}
